import { lazy, StrictMode, Suspense } from 'react';
import * as ReactDOM from 'react-dom/client';
import { AppConfigProvider } from '@fu-app/core';
import RemotesManager from './remotes/RemotesManager';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const App = lazy(() => import('./app/AuthenticatedApp'));

root.render(
  <StrictMode>
    <AppConfigProvider
      render={appConfig => {
        if (!Array.isArray(appConfig.remotes)) {
          throw new TypeError(
            'No remotes are defined. App-shel must have remote microfrontends defined in config.json.'
          );
        }
        return (
          <RemotesManager remotes={appConfig.remotes}>
            <Suspense
              fallback={
                <div className="flex w-[100vw] h-[100vh] justify-center items-center">Cargando configuración...</div>
              }
            >
              <App />
            </Suspense>
          </RemotesManager>
        );
      }}
    />
  </StrictMode>
);
